import { useCallback, useEffect, useState } from "react";
import { getConsolidado } from "../service/reportesService";

export function useConsolidado(filtros) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getConsolidado(filtros);
      setData(res || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}
